import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {PageableApiResult} from "../models/pagable-api-result.model";
import {and, comparison, eq, ge, le} from "rsql-builder";
import {Order} from "../models/order.model";
import {OrderListFilter} from "../models/order-list-filter.model";

@Injectable({
  providedIn: 'root'
})
export class OrderApiService {

  private baseUrl:string = environment.apiBaseUrl+"/order/portal";

  constructor(
    private httpClient: HttpClient
  ) { }

  getOrderList(): Observable<Order[]> {
      return this.httpClient.get<Order[]>(environment.apiBaseUrl+"/orders/portal/orders");
  }


  getOrder(id): Observable<Order> {
    return this.httpClient.get<any>(this.baseUrl+`/${id}`);
  }

  createOrder(importe: any, userReceiverId: any, password:string) {
    let req = {
      userReceiverID:userReceiverId,
      importe:importe,
      password
    }
    return this.httpClient.post<any>(environment.apiBaseUrl+`/orders/portal/orders/add`,req);
  }

  searchOrderList(filter: OrderListFilter): Observable<PageableApiResult<Order>> {
    const comps = [];
    console.log('Filtros Service', filter);
    if(filter.dateFilter && filter.dateFilter.from) {
      comps.push(comparison("date", ge(filter.dateFilter.from)))
    }
    if(filter.dateFilter && filter.dateFilter.to) {
      comps.push(comparison("date", le(filter.dateFilter.to)))
    }
    if(filter.id) {
      comps.push(comparison("id", eq(filter.id)))
    }
    if(filter.montoMinimo) {
      comps.push(comparison("amount", ge(filter.montoMinimo)))
    }
    if(filter.montoMaximo) {
      comps.push(comparison("amount", le(filter.montoMaximo)))
    }
    if(filter.status) {
      comps.push(comparison("status.id", eq(filter.status)))
    }
    let params = null;
    if (comps.length > 0) {
      let q = and(...comps).toString();
      params = new HttpParams().set("rquery", q);
    }
    if (filter.sortByAmount) {
      params = params.append("rsort", "amount").append("rdirection",filter.sortByAmount);
    }
    if (filter.sortByDate) {
      params = params.append("rsort", "date").append("rdirection",filter.sortByDate);
    }

    return this.httpClient.get<PageableApiResult<Order>>(
      environment.apiBaseUrl+ "/orders/portal/orders"+
      `/${filter.page}/${filter.size}`,
      {params}
    );

  }
}

